import { render, staticRenderFns } from "./Leaves.vue?vue&type=template&id=331bc600&lang=html&"
import script from "./Leaves.vue?vue&type=script&lang=js&"
export * from "./Leaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Leaves.vue"
export default component.exports